<template>
	<div id="bottom">
		<div class="bg-color-black">
			<div class="d-flex jc-center">
				<Swiper class="swiper" :options="swiperOption" ref="chartSwiper" v-if="echartArr > 0">
					<Swiper-slide v-for="(echart,index) in echartArr" :key="index" style="width:4rem;">
						<div :id="index" class="chart-container" style="height:3.9rem;margin-top:-0.5rem"></div>
					</Swiper-slide>
				</Swiper>
			</div>
		</div>
	</div>
</template>

<script>
	const echarts = require("echarts");
	import axios from 'axios';
	import { Swiper, SwiperSlide } from 'vue-awesome-swiper' // 导入组件
	import "swiper/css/swiper.css"; // 导入样式
	export default {
		components: {
			Swiper,
			SwiperSlide
		},
		inject: ['reload'],
		data() {
			return {
				swiperOption: {},
				echartArr: 0
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，5分钟
			let _this = this;
			setInterval(() => {
				_this.reload(); // 重新加载组件
			}, 1000 * 60 * 5);
		},
		methods: {
			swiperInit(size) {
				let _this = this;
				//初始化轮播组件属性
				if (size > 6) {
					_this.swiperOption = {
						notNextTick: true,
						observer: true, //修改swiper自己或子元素时，自动初始化swiper
						observeParents: true, //修改swiper的父元素时，自动初始化swiper
						slidesPerView: 6, //每页显示数量
						speed: 2500, //滑动速度
						loop: true, //循环轮播
						autoplay:{
							delay:0,
							disableOnInteraction: false
						}
					}
				} else {
					_this.swiperOption = {
						slidesPerView: size
					}
				}
			},
			initData() {
				let _this = this;
				axios.get(this.$baseURL + '/dataView/pay/getPayInfo').then((res) => {
					var result = res.data.result;
					_this.echartArr = result.length;
					this.$nextTick(() => {
						var pieEcharts = document.getElementsByClassName('chart-container');
						for (let i = 0; i < pieEcharts.length; i++) {
							let pieEchart = echarts.init(pieEcharts[i]);
							var index = pieEcharts[i].id;
							console.log(index);
							let option = {
								title: {
									text: result[index].orgName,
									x: 'center',
									top: '88%',
									textStyle: {
										color: '#ffe500',
										fontSize: 14
									}
								},
								series: [{
										type: 'pie', //饼图
										z: -1,
										radius: [0, '50%'],
										itemStyle: {
											borderWidth: 0,
											shadowBlur: 0,
											shadowColor: 'rgba(33, 23, 46, 0.1)'
										},
										label: {
											show: true,
											position: 'center', //中间文字显示
											color: '#4c4a4a',
											formatter: '{total|' + result[index].total + '}' + ' {active|人} ',
											rich: {
												total: {
													fontSize: 25,
													lineHeight: 30,
													color: '#ffe500'
												},
												active: {
													fontSize: 20,
													lineHeight: 30,
													color: '#ffe500'

												},
											},
										},
										data: [{
											value: 100,
											itemStyle: {
												color: 'rgba(0, 0, 0, 0)', //圆环颜色
											}
										}]
									},
									{
										type: 'gauge', //仪表盘
										radius:'50%' ,
										min: 0,
										max: 100,
										anchor: {
											show: false,
											showAbove: true,
											size: 18,
											itemStyle: {
												color: '#FAC858'
											}
										},
										axisTick: {
											show: false
										},
										splitLine: {
											show: false
										},
										axisLabel: {
											show: false
										},
										pointer: {
											show: false,
											icon: 'none',
											width: 8,
											length: '80%',
											offsetCenter: [0, '8%']
										},
										progress: {
											show: true,
											overlap: true,
											roundCap: true,
											width: 20 //动态环状宽度
										},
										axisLine: {
											roundCap: true, //是否在两端显示成圆形
											lineStyle: { // 属性lineStyle控制线条样式 
												width: 20, //静态环状宽度
												color: [
													[0, 'rgba(84, 192, 118, 1)'],
													[1, 'rgba(48, 37, 198, 0.5)']
												]
											}

										},
										data: [{
												name: '未缴', //不在线比例
												title: {
													offsetCenter: ['60%', '130%']
												},
												detail: {
													offsetCenter: ['60%', '126%'],
													formatter: '{c|' + result[index].notCount + '}'
												},
												itemStyle: {
													color: 'rgba(255, 162, 0,1)'
												}
											},
											{
												value: Math.round(result[index].payCount/result[index].total*100),
												name: '已缴',
												title: {
													offsetCenter: ['-60%', '130%']
												},
												detail: {
													offsetCenter: ['-60%', '126%'],
													formatter: '{b|' + result[index].payCount + '}'
												},
												itemStyle: {
													color: 'rgba(255, 162, 0, 1)' //动态图颜色
												}
											},
										],
										title: {
											fontSize: 14, //是否缴费文字
											color: '#fff',
										},
										detail: {
											width: 20,
											height: 70,
											fontSize: 16,
											borderRadius: 20,
											// 图例文字样式
											rich: {
												a: {
													align: 'left',
													color: '#C0C5DC',
													fontSize: 18,
													lineHeight: 32,
													Top:20
												},
												b: {
													color: 'rgba(255, 162, 0, 1)',
													fontSize: 18
												},
												c: {
													color: 'rgba(170, 173, 198, 1.0)',
													fontSize: 18
												}
											},
										}
									}
								],
								tooltip: {
									show: false
								}
							}
							pieEchart.setOption(option)
						}
					})
					this.swiperInit(result.length); //初始化轮播组件
				}).catch((error) => {
					console.log(error);
				})
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};
</script>

<style lang="scss">
	#bottom {
		// .swiper-container{overflow: visible;}
		.swiper-wrapper {
			transition-timing-function: linear !important;
			transform: translate3d(-AAApx, 0px, 0px) !important;
		}

	}
</style>

